// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"Y0-z"};